export default __webpack_public_path__ + "static/media/mobile_main_reward2.70598e26.png";